import axios from "../../config/axiosConfig.js";
import {
  CANCEL_EWAY_BILL_REPORT_REQUEST,
  CANCEL_EWAY_BILL_REPORT_SUCCESS,
  CANCEL_EWAY_BILL_REPORT_FAILURE
} from "../types/cancel-eway-bill-report-types.js";

export const getCancelEWayBillReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CANCEL_EWAY_BILL_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/cancel-eway-bill-report/getReport?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: CANCEL_EWAY_BILL_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: CANCEL_EWAY_BILL_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: CANCEL_EWAY_BILL_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getPendinngEInvoiceReport = (params) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      const defaultParams2 = {
        filterType: params?.filterType, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/cancel-eway-bill-report/getReport?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          return response.data; // Return data for further processing if needed
        }
      }).catch((error) => {
        console.error("Error fetching Pending Einvoice Report:", error);
      });
    } catch (error) {
      console.error("Error fetching Pending Einvoice Report:", error);
    }
  };
};

export const clearCancelEWayBillReport = () => {
  return async (dispatch) => {
    dispatch({ type: CANCEL_EWAY_BILL_REPORT_SUCCESS, payload: {} });
  }
}
